import React from "react";

import BooleanSelector from "./BooleanSelector";

export default function AllowNullBSalcoSelector(props) {
  return <BooleanSelector label="Permitir código Salcobrand nulo" {...props} />;
}
